export default __webpack_public_path__ + "static/media/logoblack.a6b51787.png";